import React, { useEffect, useState } from 'react';
import './myprojectscontent.css';
import MyActiveProjects from './myactiveprojects';
import MyClosedProjects from './myclosedprojects';
import MyLikedProjects from './mylikedprojects';
import { useParams } from 'react-router-dom';
import { getLoginId } from '../../Authentication/AuthSvc/authservice';

const API_URL = process.env.REACT_APP_API_URL;

const MyProjectsContent = () => {

    const [myprojselection, setMyProjSelection] = useState('active');
    const { id } = useParams();
    const [endpoint, setEndpoint] = useState(`/myprojects/active/${id}`);
    const [removelikedchecked, setRemoveLikedChecked] = useState(false);
    const [chkprojexists, setChkProjExists] = useState(null);
    const loginID = getLoginId();

    const handleChkProjExists = (projexists) => {
        setChkProjExists(projexists);
    }

    const handleprojselection = (selection) => {
        setMyProjSelection(selection);

        if (selection === 'active') {
            setEndpoint(`/myprojects/active/${id}`);
        } else if (selection === 'closed') {
            setEndpoint(`/myprojects/closed/${id}`);
        } else if (selection === 'liked') {
            setEndpoint(`/myprojects/liked/${id}`);
        }
    }

    const handleremoveallliked = async (e) => {
        e.preventDefault();
        if (removelikedchecked) {
            try {
                const response = await fetch(`${API_URL}/myprojects/removeallliked/${id}`);
            } catch (error) {
                console.error('Error deleting liked projects:', error);
            };
        }
    }

    useEffect(() => {

    }, [endpoint])

    return (
        <div className="myprojs-body">
            {loginID === id ? (
                <div className="myprojs-container">
                    <div className="myprojs-grid-item">
                        <div className="myprojs-title">
                            <h2 style={{ fontWeight: '400' }}>My Projects</h2>
                        </div>
                        <div className="myprojs-nav">
                            <div className="myprojs-navitems">
                                <button className={`projselbtn ${myprojselection === 'active' ? 'projselactive' : 'projselinactive'}`} onClick={() => handleprojselection('active')}><span className='nav-active'>Active</span></button>
                                <button className={`projselbtn ${myprojselection === 'closed' ? 'projselactive' : 'projselinactive'}`} onClick={() => handleprojselection('closed')}><span className='nav-closed'>Closed</span></button>
                                <button className={`projselbtn ${myprojselection === 'liked' ? 'projselactive' : 'projselinactive'}`} onClick={() => handleprojselection('liked')}><span className='nav-liked' >Liked</span></button>
                            </div>
                            <div className="myprojs-navfilter">
                                <span style={{ fontWeight: '390' }}>Sort by:</span>
                                <select className='nav-filter'>
                                    <option>Latest</option>
                                </select>
                            </div>
                        </div>
                        <hr />

                        <div className="myprojs-itemlist">

                            <form onSubmit={handleremoveallliked}>
                                <div className='myprojstitle-container'>
                                    {chkprojexists === null ? (
                                        <></>
                                    ) : (
                                        <>
                                            {myprojselection === 'liked' ? (
                                                <div className='myprojstitle-grid-1'>
                                                    <input type='checkbox' checked={removelikedchecked} onChange={() => setRemoveLikedChecked(!removelikedchecked)} />
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                            <div className='myprojstitle-grid-2'>
                                                <span>Name</span>
                                            </div>

                                            {myprojselection === 'liked' ? (
                                                <></>
                                            ) : (
                                                <div className='myprojstitle-grid-3'>
                                                    <span>Role</span>
                                                </div>
                                            )}

                                            <div className='myprojstitle-grid-5'>
                                                <span>Recruiting</span>
                                            </div>
                                            <div className='myprojstitle-grid-6'>
                                                <span>Phase</span>
                                            </div>
                                            <div className='myprojstitle-grid-7'>
                                                <span>Created</span>
                                            </div>
                                            <div className='myprojstitle-grid-8'>
                                                <span>Last Updated</span>
                                            </div>
                                        </>
                                    )}
                                </div>

                                <div className='results'>
                                    {myprojselection === 'active' && <MyActiveProjects endpoint={endpoint} checkprojexists={handleChkProjExists} />}
                                    {myprojselection === 'closed' && <MyClosedProjects endpoint={endpoint} checkprojexists={handleChkProjExists} />}
                                    {myprojselection === 'liked' && <MyLikedProjects endpoint={endpoint} checkprojexists={handleChkProjExists} />}
                                </div>

                                {myprojselection === 'liked' && removelikedchecked ? (
                                    <div className='removelikebtn-grid'>
                                        <button className='removelikebtn' type="submit">Remove All</button>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="listdeny-grid-container">
                    <div className="listdenycontainer">
                        <div className="listdenytitle">
                            <h2 style={{ fontWeight: '400', textAlign: 'center', marginBottom: '1rem' }}>Unauthorised Access.</h2>
                        </div >
                    </div>
                </div>
            )}

        </div>
    );
};

export default MyProjectsContent;
